import { defineComponent } from '@vue/composition-api';
import { ResizeSensor } from 'css-element-queries';
export default defineComponent({
    name: 'DpBulb',
    props: {
        subtitle: { type: String, default: '' },
        state: { type: String, default: null },
        title: { type: String, default: null },
        value: { type: [String, Number], default: '' },
    },
    data() {
        return {
            resizeSensor: null,
            height: null,
        };
    },
    computed: {
        hasTitle() {
            return !!this.title;
        },
        text() {
            return this.value.toString();
        },
        style() {
            const { height } = this;
            if (!height)
                return undefined;
            return {
                height: `${height}px`,
            };
        },
    },
    mounted() {
        this.resizeSensor = new ResizeSensor(this.$el, this.resize);
        this.resize();
    },
    beforeDestroy() {
        this.resizeSensor?.detach(this.resize);
    },
    methods: {
        resize() {
            this.height = this.$refs.innerElement.clientWidth;
        },
    },
});
